module.exports = require("core-js-pure/stable/object/define-properties");


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/@babel/runtime-corejs3/core-js-stable/object/define-properties.js
// module id = 185
// module chunks = 1